import { createTheme, ThemeProvider } from '@mui/material/styles';

const theme = createTheme({
    typography: {
        fontFamily: '"Times New Roman", Times, serif',
        h1: {
            fontFamily: '"Times New Roman", Times, serif',
            fontWeight: 600,
        },
        h2: {
            fontFamily: '"Times New Roman", Times, serif',
            fontWeight: 600,
        },
        h3: {
            fontFamily: '"Times New Roman", Times, serif',
            fontWeight: 600,
        },
        h4: {
            fontFamily: '"Times New Roman", Times, serif',
            fontWeight: 600,
        },
        h5: {
            fontFamily: '"Times New Roman", Times, serif',
            fontWeight: 600,
        },
        h6: {
            fontFamily: '"Times New Roman", Times, serif',
            fontWeight: 600,
        },
        subtitle1: {
            fontFamily: '"Times New Roman", Times, serif',
            fontWeight: 500,
        },
        subtitle2: {
            fontFamily: '"Times New Roman", Times, serif',
            fontWeight: 500,
        },
        body1: {
            fontFamily: '"Times New Roman", Times, serif',
        },
        body2: {
            fontFamily: '"Times New Roman", Times, serif',
        },
        button: {
            fontFamily: '"Times New Roman", Times, serif',
            fontWeight: 500,
            textTransform: 'none',
        },
        caption: {
            fontFamily: '"Times New Roman", Times, serif',
        },
        overline: {
            fontFamily: '"Times New Roman", Times, serif',
        },
    },
});

const ThemeWrapper = ({ children }) => (
    <ThemeProvider theme={theme}>
        {children}
    </ThemeProvider>
)

export { ThemeWrapper }
